import React, { useContext } from 'react';
import { GettextContext } from 'rootReact/context';

export default ({ children }) => {
    const gettext = useContext(GettextContext);
    return gettext.getString(children);
};
